import { omit } from "./object";

export function createPropsFilter<
  T extends Record<string, any>,
  K extends (keyof T)[] = (keyof T)[],
>(
  keys: K,
  defaultValues?: Partial<T>,
): <O>(props: T & O) => [T, Omit<O, K[number]>] {
  return function <O extends T>(props: O) {
    // Simply pick off the props you care about—no stringify, no cache.
    const filteredProps = Object.fromEntries(
      Object.entries(props)
        .filter(([k]) => keys.includes(k as any))
        .map<[string, any]>(([k, v]) => [k, v ?? defaultValues?.[k]]),
    ) as T;

    const remaining = omit(props, keys);
    return [filteredProps, remaining];
  };
}
